<template>
  <fragment v-if="!closedStatus.includes(serviceInfo.serviceStatus)">
    <ActiveAlertsList
      v-if="!loadingDetail"
      header="Active Alerts"
      className="urgent"
      :alertList="activeAlertList"
    />
    <ActiveAlertsList
      v-if="!loadingDetail"
      header="System Insights"
      className="watching"
      :alertList="systemInsightList"
      hideDismiss
      hideExport
    />
    <CycleHistoryTable />
    <PastAlertsTable />
    <PastLeakAlertsTable />
    <PastServicesTable />
  </fragment>
</template>
<script>
import ActiveAlertsList from '@shared/components/service/leadDetail/ActiveAlertsList.vue';
import serviceMixin from '@shared/mixins/serviceMixin';
import CycleHistoryTable from './CycleHistoryTable.vue';
import PastAlertsTable from './PastAlertsTable.vue';
import PastLeakAlertsTable from './PastLeakAlertsTable.vue';
import PastServicesTable from './PastServicesTable.vue';

export default {
  name: 'ServiceItems',
  components: {
    ActiveAlertsList,
    CycleHistoryTable,
    PastServicesTable,
    PastAlertsTable,
    PastLeakAlertsTable,
  },
  mixins: [serviceMixin],
  mounted() {
    if (this.serviceInfo.uid) {
      this.$store.dispatch('getPastAlerts', this.serviceInfo.uid);
    }
  },
};
</script>
